import {
    faPlay,
    faShoePrints,
    faThLarge,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Nav, Tab } from "react-bootstrap";
import { IEtapa } from "../../../../../../../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import AcoesEtapa from "./AcoesEtapa";
import GeralEtapa from "./GeralEtapa";
import GruposEtapa from "./GruposEtapa";

interface IEditarEtapaProps {
    idEtapa: number;
    dsEtapa: string;
    flAtivo: boolean;
    lstEtapas: Array<IEtapa>;
    updateList: () => void;
    idModulo: number;
}

export default function EditarEtapa(props: IEditarEtapaProps) {
    return (
        <Tab.Container defaultActiveKey={props.flAtivo ? "geral" : "grupos"}>
            <Modal.Header className="flex-wrap">
                <Modal.Title className="card-title d-flex flex-row flex-nowrap">
                    <FontAwesomeIcon icon={faShoePrints} className="mr-2" />
                    <h3 className="card-label">{props.dsEtapa}</h3>
                </Modal.Title>
                <div className="card-toolbar">
                    <Nav
                        variant="tabs"
                        role="tablist"
                        className="nav-tabs nav-bold nav-tabs-line"
                    >
                        {props.flAtivo ? (
                            <>
                                <Nav.Item>
                                    <Nav.Link eventKey="geral">
                                        <span className="nav-icon">
                                            <FontAwesomeIcon icon={faThLarge} />
                                        </span>
                                        <span className="nav-text">Geral</span>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="acoes">
                                        <span className="nav-icon">
                                            <FontAwesomeIcon icon={faPlay} />
                                        </span>
                                        <span className="nav-text">Ações</span>
                                    </Nav.Link>
                                </Nav.Item>
                            </>
                        ) : null}
                        <Nav.Item>
                            <Nav.Link eventKey="grupos">
                                <span className="nav-icon">
                                    <FontAwesomeIcon icon={faUsers} />
                                </span>
                                <span className="nav-text">Grupos</span>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
            </Modal.Header>

            <Modal.Body>
                <Tab.Content>
                    {props.flAtivo ? (
                        <>
                            <Tab.Pane eventKey="geral">
                                <GeralEtapa
                                    updateList={props.updateList}
                                    lstEtapas={props.lstEtapas}
                                    idEtapa={props.idEtapa}
                                />
                            </Tab.Pane>
                            <Tab.Pane eventKey="acoes">
                                <AcoesEtapa
                                    idEtapa={props.idEtapa}
                                    lstEtapas={props.lstEtapas}
                                />
                            </Tab.Pane>
                        </>
                    ) : null}
                    <Tab.Pane eventKey="grupos">
                        <GruposEtapa
                            idEtapa={props.idEtapa}
                            idModulo={props.idModulo}
                        />
                    </Tab.Pane>
                </Tab.Content>
            </Modal.Body>
        </Tab.Container>
    );
}
